// FilterBar — Wave 2. One clean row of compact multi-select dropdowns that
// replaces the old stacked chip rows AND the big system toggle. Search sits
// above; a single "Clear all filters" link appears when anything is active.

import { Search } from "lucide-react";
import MultiSelectDropdown from "./MultiSelectDropdown";
import { STATUSES, PRIORITIES, TYPES } from "../../constants/enums";
import { assigneeFilterOptions } from "../../lib/assignees";

const SYSTEM_OPTS = [
  { value: "1", label: "Talmia 1", colour: "#D97706" },
  { value: "2", label: "Talmia 2", colour: "#14b8a6" },
  { value: "both", label: "Both", colour: "#d946ef" },
];
const SHOW_OPTS = [
  { key: "all", label: "Everyone" },
  { key: "mine", label: "Assigned to me" },
  { key: "created", label: "Created by me" },
];

export default function FilterBar({
  search, setSearch,
  talmias, setTalmias,
  areaIds, setAreaIds,
  types, setTypes,
  statuses, setStatuses,
  priorities, setPriorities,
  assignees, setAssignees,
  ownership, setOwnership,
  areas = [], users = [],
  onClearAll, hasFilter,
}) {
  const areaOpts = areas.map((a) => ({ value: a.id, label: a.label, colour: a.colour }));
  const asOpt = (arr) => arr.map((v) => ({ value: v, label: v }));

  return (
    <div className="card-dark p-4 mb-5 space-y-3" data-testid="filter-bar">
      <div className="flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-[220px]">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            type="text" placeholder="Search by title or description..."
            className="input-dark" style={{ paddingLeft: "36px" }} value={search}
            onChange={(e) => setSearch(e.target.value)}
            data-testid="items-search-input"
          />
        </div>
        {hasFilter && (
          <button
            type="button" onClick={onClearAll}
            className="px-3 py-2 rounded-lg text-xs text-slate-300 border border-white/10 hover:bg-white/5"
            data-testid="filters-clear"
          >
            Clear all filters
          </button>
        )}
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <MultiSelectDropdown label="System"   testid="system"   options={SYSTEM_OPTS}          selected={talmias}    onChange={setTalmias} width="min-w-[130px]" />
        <MultiSelectDropdown label="Area"      testid="area"     options={areaOpts}             selected={areaIds}    onChange={setAreaIds} width="min-w-[130px]" />
        <MultiSelectDropdown label="Type"      testid="type"     options={asOpt(TYPES)}         selected={types}      onChange={setTypes} width="min-w-[120px]" />
        <MultiSelectDropdown label="Status"    testid="status"   options={asOpt(STATUSES)}      selected={statuses}   onChange={setStatuses} width="min-w-[120px]" />
        <MultiSelectDropdown label="Priority"  testid="priority" options={asOpt(PRIORITIES)}    selected={priorities} onChange={setPriorities} width="min-w-[130px]" />
        <MultiSelectDropdown label="Assignee"  testid="assignee" options={assigneeFilterOptions(users)} selected={assignees} onChange={setAssignees} width="min-w-[140px]" />

        {/* Show scope — small segmented control */}
        <div className="inline-flex items-stretch gap-0.5 rounded-lg p-0.5 border border-white/10 bg-white/[0.02]" data-testid="filter-scope">
          {SHOW_OPTS.map((o) => (
            <button
              key={o.key}
              type="button"
              onClick={() => setOwnership(o.key)}
              data-testid={`filter-scope-${o.key}`}
              className={`px-2.5 h-8 rounded-md text-[11px] font-medium transition-colors ${
                ownership === o.key ? "bg-orange-500/15 text-orange-200" : "text-slate-400 hover:text-white hover:bg-white/5"
              }`}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
